export var global = typeof window !== 'undefined' ? window : {};



//////////////////
// WEBPACK FOOTER
// ../~/@juggle/resize-observer/lib/utils/global.js
// module id = 211
// module chunks = 0